export enum LorenAutomationActionEnum {
  SEND_USER_EMAIL = "SEND_USER_EMAIL",
  SEND_ALL_USERS_EMAIL = "SEND_ALL_USERS_EMAIL",
  SEND_USER_PUSH_NOTIFICATION = "SEND_USER_PUSH_NOTIFICATION",
  SEND_ALL_USERS_PUSH_NOTIFICATION = "SEND_ALL_USERS_PUSH_NOTIFICATION",
  SEND_USER_SMS = "SEND_USER_SMS",
  SET_RELAY_ON = "SET_RELAY_ON",
  SET_RELAY_OFF = "SET_RELAY_OFF",
}
